import React, { Component } from "react";
import { connect } from "react-redux";
import { updateHeaderInfo, getUserDetails, trackPage } from "../actions";
import { CopyrightWidget } from "../components";
import { APPVERSION, APPID } from "../common";
import { Divider, Typography } from "@material-ui/core";
import { deviceData, setContainer, APPYEAR } from "../common";
import { isBrowser } from 'react-device-detect';

class Errors extends Component {
    state = {
        appversion: APPVERSION,
        appid: APPID,
        year: APPYEAR(),
    }
x
    componentDidMount = async () => {
        const {mcid, key} = this.props.auth_feedback;
        let tracking = deviceData(this.props.location, 'error');
        tracking.action = 'error'

        if (typeof this.props.location.prevLoc !== 'undefined') {
            tracking.detail = this.props.location.prevLoc.pathname;
            tracking.detailvar = 'pathname';
        }

        const _obj = {
            mcid: mcid,
            key: key,
            tracking: tracking
        }

        await this.props.trackPage(_obj)

        return this.props.updateHeaderInfo({
            route:"/error", 
            name: "SASP", 
            iconTwo: 'menu', 
            iconOne: 'home',
            color: "#00567a"
        });
    };

    componentDidUpdate = async (prevProps, prevState) => {
        
    }

    render() {
        return (
            <>
                <div className="aua-overflow anchor" style={setContainer(isBrowser)}>
                    <Typography className="homeDividerText">Error</Typography>
                    <div style={{ padding: "8px 0 16px"}} >
                        <div className="width100 flex-col-start padding-top-16 padding-bottom-24">
                            <div className="margin-bottom-8 width100 flex-row-between">
                                <div className="lineHeight-16667">
                                    <p>
                                        There has been an error within the app.
                                    </p>
                                    {this.props.location.message
                                        ?(<p>{this.props.message}</p>):null
                                    }
                                    <p>
                                        Please try again later.
                                    </p>
                                    <p>
                                        If you have any questions please contact the Office of Education at <a href="mailto:edudcation.auanet.org?cc=isperry@auanet.org;pkerley@auanet.org&subject=SASP%20Comment" target="_new">education@auanet.org</a>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <CopyrightWidget 
                        begin={2014}
                        year={this.state.year}
                        textAlign={'center'}
                        className="width100 margin-top-48" 
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details } = state.auth;
    const { error } = state.question;

    return {
        auth_feedback,
        user_details,
        error
    };
};

const ErrorScreen = connect(mapStateToProps, { updateHeaderInfo, getUserDetails, trackPage })(
    Errors
);

export { ErrorScreen };
